// extracted by mini-css-extract-plugin
module.exports = {"fab":"ChatbotWidget_fab__9zLIZ","fabButton":"ChatbotWidget_fabButton__jj3R7"};